import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';

type TypeCheckSelfCertificateResponse = {
  code: string;
  message: string;
  data: {
    /** 인증 결과
     * @remarks 반환되는 응답 코드
     * NOT_FOUND : 본인인증 시간 초과로 인해 캐시에서 데이터 조회가 불가한 경우
     * IN_PROGRESS: 본인인증이 진행중인 경우
     * FAILURE: 인증에 실패한 경우
     * SUCCESS: 인증에 성공한 경우
     * PASSED_BY_ADMIN: 관리자에 의해 본인인증이 임시 처리된 경우
     * CERTIFICATION_SUCCESS_INFO_MISMATCH : 본인인증은 성공했으나 컬리로에 입력된 정보와 일치하지 않는 경우
     * FOREIGNER_NOT_SUPPORTED: 외국인 등록번호로 본인인증은 지원하지 않는 경우
     * */
    status: TypeCodeState;
    /** 인증 결과 모달에 표시할 메세지 */
    message: string;
  };
};
/** @description 본인인증 결과를 조회하는 훅 */
export const useCheckSelfCertificate = () => {
  const [stopPolling, setStopPolling] = useState(true);

  const { data, isError } = useQuery({
    queryKey: ['labor-accounts', 'certification-result'],
    queryFn: () => {
      const endPoint = '/labor-accounts/certification-result';
      return axiosInstance.get<TypeCheckSelfCertificateResponse>(endPoint);
    },
    enabled: !stopPolling,
    refetchInterval: () => {
      if (isError || stopPolling) {
        return false;
      }

      return 1000;
    },
    gcTime: 0,
  });

  return { data: data?.data, setStopPolling };
};
